import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#20201f',
      light: '#4b4946',
      dark: '#111110',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#7d8b73',
      light: '#9eaa96',
      dark: '#58634f',
      contrastText: '#ffffff',
    },
    success: {
      main: '#2e7d32',
      light: '#4caf50',
      dark: '#1b5e20',
    },
    warning: {
      main: '#ed6c02',
      light: '#ff9800',
      dark: '#e65100',
    },
    error: {
      main: '#d32f2f',
      light: '#ef5350',
      dark: '#c62828',
    },
    info: {
      main: '#4c7f95',
      light: '#6fa3b7',
      dark: '#315b6b',
    },
    background: {
      default: '#f6f5f3',
      paper: '#ffffff',
    },
    text: {
      primary: '#1f1f1d',
      secondary: '#6f6f6b',
    },
    divider: '#e8e5e1',
    action: {
      hover: 'rgba(32, 32, 31, 0.055)',
      selected: 'rgba(32, 32, 31, 0.08)',
      focus: 'rgba(76, 127, 149, 0.18)',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#f6f5f3',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 700,
        },
        containedPrimary: {
          boxShadow: '0 12px 26px rgba(32, 32, 31, 0.14)',
          '&:hover': {
            backgroundColor: '#111110',
            boxShadow: '0 14px 30px rgba(32, 32, 31, 0.18)',
          },
        },
        outlined: {
          borderColor: '#e2dfda',
          color: '#20201f',
          '&:hover': {
            borderColor: '#d4d0ca',
            backgroundColor: 'rgba(32, 32, 31, 0.045)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          border: '1px solid #e9e6e2',
          boxShadow: '0 14px 40px rgba(35, 35, 33, 0.055)',
          backgroundImage: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundImage: 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: '#61615d',
          fontWeight: 800,
          backgroundColor: '#f4f2ef',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e3e0db',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d4d0ca',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#4c7f95',
            boxShadow: '0 0 0 3px rgba(76, 127, 149, 0.14)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 700,
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export default theme;
